import { Badge, Col, Container, Row } from "react-bootstrap"
import { Link, useParams } from "react-router-dom"
import './property.scss'
import { PropertyEntry } from "../../../Components/PropertyEntry/PropertyEntry"
import { useGetPropertyByIdQuery, useGetBookingsQuery, useGetTurnoversQuery } from "../../../services/bClientApi"
import GenericResourceAccess from "../../../Components/ResourceAccess/GenericResourceAccess"
import PropertyAmenities from "../../../Components/PropertyAmenity/PropertyAmenities/PropertyAmenities"
import DataLogList from "../../../Components/DataLogs/DataLogList"
import timeService from "../../../services/time/timeService"
import VRBOIntegration from "../../../Components/VRBOIntegration/VRBOIntegration"
import Collapsible from "../../../Components/Collapsible/Collapsible"
import canAccess from "../../../services/accessService/accessService"
import { FEATURE_FLAGS } from "../../../Config/config"

export default function PropertyPage() {

  const { propertyId } = useParams()
  const {
    data: propertyData,
    error,
  } = useGetPropertyByIdQuery(propertyId ? propertyId : '')

  const startOfToday = timeService.createLuxonDate(new Date()).startOf('day').toMillis()
  const endOfToday = timeService.createLuxonDate(new Date()).endOf('day').toMillis()

  const { data: bookingsData, isLoading: bookingsLoading } = useGetBookingsQuery({
    bookingsQuery: {
      propertyId,
      checkIn: startOfToday,
      checkOut: endOfToday,
      bookingStatus: ['new', 'pending', 'confirmed'],
    },
    pagination: { page: 1, limit: 10 },
  }, { skip: !propertyId })

  const { data: turnoversData, isLoading: turnoversLoading } = useGetTurnoversQuery({
    turnoversQuery: {
      propertyId,
      type: 'checkOut',
      status: ['new','pending', 'started', 'completed'],
      scheduledForEnd: endOfToday,
    },
    pagination: { page: 1, limit: 1 },
  }, { skip: !propertyId })

  const activeBooking = bookingsData?.docs?.find((booking: any) => {
    const checkIn = timeService.dateToMillis(booking.checkIn)
    const checkOut = timeService.dateToMillis(booking.checkOut)
    const now = Date.now()
    return checkIn <= now && checkOut >= now
  })
  const isOccupied = !!activeBooking
  const isNotReady = turnoversData?.docs?.length > 0


  return (
    <Container>
      <Row>
        <Col
          xs={12}
          lg={9}
        >
          <h1>Single Property Page</h1>

          <div className="d-inline mb-2 text-uppercase">
            {bookingsLoading ? (
              <Badge bg="secondary">Checking occupancy...</Badge>
            ) : isOccupied ? (
              <Link to={`/booking/${activeBooking._id}`}>
                <Badge bg="danger">Occupied</Badge>
              </Link>
            ) : (
              <Badge bg="success">Vacant</Badge>
            )}
            &nbsp;
            {turnoversLoading ? (
              <Badge bg="secondary">Checking readiness...</Badge>
            ) : isNotReady ? (
              <Link to={`/turnovers?page=1&limit=10&query=${encodeURIComponent(JSON.stringify({ propertyId, status: ['new','pending', 'started', 'completed'], type: 'checkOut', scheduledForEnd: endOfToday }))}`}>
                <Badge bg="warning" text="dark">Not Ready</Badge>
              </Link>
            ) : isOccupied ? (
              <></>
            ) : (
              <Badge bg="success">Clean &amp; Ready</Badge>
            )}
          </div>

          <hr />
          {error && (<>{JSON.stringify(error)}<br /></>)}

          {propertyId && propertyData && (
            <div className="property-info">
              <PropertyEntry
                propertyInfo={propertyData}
                details={true}
                disableLinks={{
                  view: 1,
                }}
              />
            </div>
          )}


          <Collapsible
            title="Resource Access"
          >
            <GenericResourceAccess resourceType="property" resourceId={propertyId} />
          </Collapsible>

          <hr />

          <Collapsible
            title="Amenities"
          >
            <PropertyAmenities propertyId={propertyId} />
          </Collapsible>

          <hr />

          {FEATURE_FLAGS.vrboIntegration && canAccess('property', 'vrboIntegration') && propertyId && propertyData && (
            <Collapsible
              title="VRBO Integration"
            >
              <VRBOIntegration propertyId={propertyId} title=""/>            
            </Collapsible>
          )}


        </Col>

        <Col
          xs={12}
          lg={3}
        >
          <DataLogList
            dataType="property"
            dataId={propertyId ? propertyId : ''}
          />
        </Col>


      </Row>
    </Container>
  )
}